// components/common/LoadingSpinner.js
import React from "react";

const LoadingSpinner = ({ size = "md", className = "" }) => {
	const sizeClasses = {
		sm: "w-4 h-4",
		md: "w-8 h-8",
		lg: "w-12 h-12",
		xl: "w-16 h-16",
	};

	return (
		<div className="flex items-center justify-center">
			<div
				className={`
          ${sizeClasses[size]}
          border-4
          border-gray-200
          border-t-blue-500
          dark:border-gray-700
          dark:border-t-blue-400
          rounded-full
          animate-spin
          ${className}
        `}
				role="status"
				aria-label="Loading"
			>
				<span className="sr-only">Loading...</span>
			</div>
		</div>
	);
};

// LoadingScreen component for full-page loading states
const LoadingScreen = () => {
	return (
		<div className="fixed inset-0 flex items-center justify-center bg-white dark:bg-gray-900 transition-colors duration-200">
			<div className="flex flex-col items-center space-y-4">
				<LoadingSpinner size="xl" />
				<div className="text-lg font-medium text-gray-700 dark:text-gray-300">
					Loading MyCron...
				</div>
			</div>
		</div>
	);
};

// LoadingOverlay component for loading states within containers
const LoadingOverlay = ({ isLoading, children }) => {
	if (!isLoading) return children;

	return (
		<div className="relative">
			{children}
			<div className="absolute inset-0 bg-white/50 dark:bg-gray-900/50 flex items-center justify-center backdrop-blur-sm">
				<LoadingSpinner size="lg" />
			</div>
		</div>
	);
};

export { LoadingSpinner, LoadingScreen, LoadingOverlay };
